import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import * as rpc from "@1games-ru/rage-rpc";
import toast from "@/domains/toasts/helpers/toast.ts";

function ToastSubscriberContainer() {
  const { t } = useTranslation();

  useEffect(() => {
    rpc.register("showNoty", (data) => {
      const { color, position, text, args } = data;

      let fn;
      switch (position) {
        case "game":
          fn = toast.game[color];
          break;
        case "npc":
          fn = toast.npc[color];
          break;
        case "action":
          fn = toast.action[color];
          break;
        case "debug":
          fn = toast.debug;
          break;
        default:
          fn = toast[color];
          break;
      }

      fn(t(`notifications:${text}`, args), text);

      return true;
    });

    return () => {
      rpc.unregister("showNoty");
    };
  }, [t]);

  return null;
}

export default ToastSubscriberContainer;
